const elasticConfig = {
    item: {
        filterLayout: 'ElasticFilterDefaultLayout',
        listLayout: 'ElasticListDefaultLayout',
        paginationLayout: 'PaginationUpdateLayout',
        pageRow: 10,
        paginationType: 'firstInitPage',
        listApiParamSet: {
            query: {
                bool: {
                    must: [
                        {match: {"i_is_delete": 0}}
                    ],
                }
            }
        },
        sortOptions: {
            default: [ {'created_at': 'desc'}],
            price: [{'i_price': 'asc'}, {'created_at': 'desc'}]
        },
        startSort: {key: 'default', order: 'desc'},
        isFirstGet: true,
        isGetFirst: true,
        listUpdateData: ['ie_season', 'ie_pattern']
    },
    select: {
        filterLayout: 'ElasticFilterNotOptionLayout',
        listLayout: 'ElasticListSelectLayout',
        paginationLayout: 'PaginationSelectLayout',
        pageRow: 10,
        paginationType: 'firstInitPage',
        listApiParamSet: {
            query: {
                bool: {
                    must: [
                        {match: {"i_is_delete": 0}}
                    ],
                }
            }
        },
        sortOptions: {
            default: [ {'created_at': 'desc'}],
            price: [{'i_price': 'asc'}, {'created_at': 'desc'}]
        },
        startSort: {key: 'default', order: 'desc'},
        isFirstGet: true,
        isGetFirst: true,
        listUpdateData: ['ie_season', 'ie_pattern']

    },
    itemRelate: {
        filterLayout: 'ElasticFilterNotOptionLayout',
        listLayout: 'ElasticListRelateSelectLayout',
        paginationLayout: 'PaginationRelateSelectLayout',
        pageRow: 10,
        paginationType: 'firstInitPage',
        listApiParamSet: {
            query: {
                bool: {
                    must: [
                        {match: {"i_is_delete": 0}}
                    ],
                }
            }
        },
        sortOptions: {
            default: [ {'created_at': 'desc'}],
            price: [{'i_price': 'asc'}, {'created_at': 'desc'}]
        },
        startSort: {key: 'default', order: 'desc'},
        isFirstGet: true,
        isGetFirst: true,
        listUpdateData: ['ie_season', 'ie_pattern']

    },
    lookbookItem: {
        filterLayout: 'ElasticFilterNotOptionLayout',
        listLayout: 'ElasticListLookbookLayout',
        paginationLayout: 'PaginationDefaultLayout',
        pageRow: 10,
        paginationType: 'firstInitPage',
        listApiParamSet: {
            query: {
                bool: {
                    must: [
                        {match: {"i_is_delete": 0}}
                    ],
                }
            }
        },
        sortOptions: {
            default: [ {'created_at': 'desc'}],
            price: [{'i_price': 'asc'}, {'created_at': 'desc'}]
        },
        startSort: {key: 'default', order: 'desc'},
        isFirstGet: true,
        isGetFirst: true,
        listUpdateData: ['ie_season', 'ie_pattern']
    },
    modalSelect: {
        filterLayout: 'ElasticFilterModalSelectLayout',
        listLayout: 'ElasticListModalSelectLayout',
        paginationLayout: 'PaginationOnlyPageRowLayout',
        pageRow: 10,
        paginationType: 'firstInitPage',
        listApiParamSet: {
            query: {
                bool: {
                    must: [
                        {match: {"i_is_delete": 0}},
                    ],
                }
            }
        },
        sortOptions: {
            default: [ {'created_at': 'desc'}],
            price: [{'i_price': 'asc'}, {'created_at': 'desc'}]
        },
        startSort: {key: 'default', order: 'desc'},
        isFirstGet: true,
        isGetFirst: true,
        listUpdateData: ['ie_season', 'ie_pattern']

    },
    brandItem: {
        filterLayout: 'ElasticFilterBrandLayout',
        listLayout: 'ElasticListBrandLayout',
        paginationLayout: 'PaginationBrandLayout',
        pageRow: 10,
        paginationType: 'firstInitPage',
        listApiParamSet: {
            query: {
                bool: {
                    must: [
                        {match: {"i_is_delete": 0}}
                    ],
                }
            }
        },
        sortOptions: {
            default: [ {'created_at': 'desc'}],
            price: [{'i_price': 'asc'}, {'created_at': 'desc'}]
        },
        startSort: {key: 'default', order: 'desc'},
        isFirstGet: true,
        isGetFirst: true,
        listUpdateData: ['ie_season', 'ie_pattern']
    },
}
export default {
    methods: {
        returnElasticConfig(type) {
            return elasticConfig[type];
        },
    },
    elasticDefaultBody: {
        query: {
            bool: {
                must: []
            }
        },
    },
    filterConfig: {
        na: { //상품이름
            type: 'query',
            classname: 'searchInput',
            option: {ela_dataField: 'i_name'}
        },
        mo: { //관리코드
            type: 'query',
            classname: 'searchInput',
            option: {ela_dataField: 'i_model'}
        },
        br: { //브랜드명
            type: 'query',
            classname: 'searchInput',
            option: {ela_dataField: 'i_brand'}
        },
        ca1: { //상품분류 첫번째
            type: 'match',
            classname: 'filterCateDepth1',
            option: {ela_dataField: 'category.level1', type: 'itemCategory', depth: 1}
        },
        ca2: { //상품분류 두번째
            type: 'match',
            classname: 'filterCateDepth2',
            option: {ela_dataField: 'category.level2', type: 'itemCategory', depth: 2}
        },
        ca3: { //상품분류 세번째
            type: 'match',
            classname: 'filterCateDepth3',
            option: {ela_dataField: 'category.level3', type: 'itemCategory', depth: 3}
        },
        ca4: { //상품분류 네번째
            type: 'match',
            classname: 'filterCateDepth4',
            option: {ela_dataField: 'category.level4', type: 'itemCategory', depth: 4}
        },
        pr: { //가격
            type: 'between',
            classname: 'filterPrice',
            option: {ela_dataField: 'i_price'}
        },
        cr: { //등록일
            type: 'between',
            classname: 'filterDate',
            option: {ela_dataField: 'created_at'},
        },
        dis: {
            type: 'match',
            classname: 'filterDisplay',
            option: {ela_dataField: 'i_display'},
        },
        isse: {
            type: 'match',
            classname: 'filterSelling',
            option: {ela_dataField: 'i_is_selling'},
        },
        isde: {
            type: 'match',
            classname: 'filterRepresentative',
            option: {ela_dataField: 'is_detail'},
        },
        fit: {
            type: 'match',
            classname: 'filterFitting',
            option: {ela_dataField: 'i_fitting'},
        },
        oco: { //컬러
            type: 'match',
            classname: 'filterColor',
            option: {ela_dataField: 'io_color'}
        },
        opa: { //패턴
            type: 'match',
            classname: 'filterPattern',
            option: {ela_dataField: 'ie_pattern'}
        },
        oto: { //톤
            type: 'match',
            classname: 'filterTone',
            option: {ela_dataField: 'io_tone'}
        },
        ose: { //시즌
            type: 'match',
            classname: 'filterSeason',
            option: {ela_dataField: 'ie_season'}
        },
    },
}
